import "./NextPreviousPageButtons.css";

import { useContext } from "react";

import { ArrowheadLeftLightIcon } from "../../../../../assets";
import { DealJourneyNavigatorPages } from "../../../../../constants";
import { Button } from "../../../../../widget";
import { NewDealJourneyContext } from "../../NewDealJourneyContext";

const getPreviousPage = (currentPage: DealJourneyNavigatorPages): DealJourneyNavigatorPages => {
  const index = Object.values(DealJourneyNavigatorPages).findIndex((page) => page === currentPage);

  return Object.values(DealJourneyNavigatorPages)[index - 1];
};

export const NextPreviousPageButtons = (): JSX.Element => {
  const { currentPage, handlePageChange, handleValidateAndNext } = useContext(NewDealJourneyContext);

  return (
    <div className="NextPreviousPageButtonsContainer">
      {currentPage !== DealJourneyNavigatorPages.DETAILS && (
        <Button
          text="Previous"
          variant="tertiary"
          hasNoPadding
          icon={<ArrowheadLeftLightIcon className="ArrowheadLeftBlueIcon" />}
          iconPosition="left"
          onClick={() => handlePageChange(getPreviousPage(currentPage))}
          corners="rounded"
          size="smallLarge"
        />
      )}
      {currentPage !== DealJourneyNavigatorPages.WORKFLOW && (
        <Button
          text="Next"
          variant="primary"
          hasNoPadding
          icon={<ArrowheadLeftLightIcon className="ArrowheadRightLightIcon" />}
          onClick={() => handleValidateAndNext(false)}
          corners="rounded"
          size="smallLarge"
        />
      )}
    </div>
  );
};
